import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from './components/components.module';
import { DirectivesModule } from './directives/directives.module';
import { PipeModule } from './pipe/pipe.module';

@NgModule({

  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    DirectivesModule,
    PipeModule,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    DirectivesModule,
    PipeModule
  ]
})
export class SharedModule { }
